// extracted by mini-css-extract-plugin
export default {"container":"style_container__FePCw","component":"style_component__V9NXb","descriptionContainer":"style_descriptionContainer__P9ElU","expandIcon":"style_expandIcon__EZkiJ"};